<script setup lang="ts">
import { computed, ref } from "vue";
import FilePicker from "./FilePicker.vue";
import SelectSubscribers from "../../../components/common/forms/SelectSubscribers.vue";
import { ImportingService, processMutuaFile } from "../utils/processors/mutua";
import WorkgroupCentralSelector from "@/components/common/forms/WorkgroupCentralSelector.vue";
import { useStore } from "@/utils/useStore";

const format = ref("mutua");
const file = ref<File | null>(null);
const subscriber = ref("");
const loading = ref(false);

const store = useStore();

const wgs = ref<{ wgId: number; centralId: number }[]>(
  store.getters["app/defaultSelectedWorkgroupAndCentral"]
);

const wg = computed(() => wgs.value?.[0]?.wgId ?? -1);
const central = computed(() => wgs.value?.[0]?.centralId ?? -1);

const emit = defineEmits<{
  (e: "preview", services: ImportingService[]): void;
}>();

const handleSubmit = async () => {
  loading.value = true;
  if (!file.value) return;
  try {
    switch (format.value) {
      case "mutua":
        const services = await processMutuaFile(file.value, wg.value, central.value);
        emit("preview", services);
        break;
    }
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <el-form v-loading="loading" label-position="top" size="mini">
    <el-form-item label="Workgroup">
      <WorkgroupCentralSelector v-model="wgs" :allow-select-workgroups="false" />
    </el-form-item>
    <el-form-item label="Formato">
      <el-select v-model="format" placeholder="Selecciona un formato">
        <el-option label="Mutua" value="mutua" />
      </el-select>
    </el-form-item>
    <el-form-item label="Archivo">
      <FilePicker v-model="file" />
    </el-form-item>
    <el-form-item label="Abonado">
      <SelectSubscribers v-model="subscriber" />
    </el-form-item>
    <el-button type="primary" size="mini" :disabled="!file" class="mt-2" @click="handleSubmit">
      Continuar
    </el-button>
  </el-form>
</template>
